/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import t from"react";var r;let a=null!=(r=t.startTransition)?r:function(t){t()};export{a as startTransition};
//# sourceMappingURL=start-transition.js.map
